module.exports = __webpack_public_path__ + "img/pr-5.b836d684.png";